import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import IntlMessages from 'util/IntlMessages';
import styles from './LoadingState.module.scss';

const LoadingState = ({
  label,
  variant,
  className,
  testId,
}) => {
  const rootClassName = [styles.root, styles[variant], className].filter(Boolean).join(' ');

  return (
    <div
      className={rootClassName}
      role="status"
      aria-live="polite"
      aria-busy="true"
      data-testid={testId}
    >
      <span className={styles.visual} aria-hidden="true">
        <span className={styles.halo} />
        <CircularProgress className={styles.spinner} size={30} thickness={4.2} />
      </span>
      <span className={styles.label}>
        {label || <IntlMessages id="common.loading" />}
      </span>
    </div>
  );
};

LoadingState.propTypes = {
  label: PropTypes.node,
  variant: PropTypes.oneOf(['page', 'panel', 'compact']),
  className: PropTypes.string,
  testId: PropTypes.string,
};

LoadingState.defaultProps = {
  label: null,
  variant: 'panel',
  className: null,
  testId: 'loading-state',
};

export default LoadingState;
